const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
    items: [],
    type: "",
    search: "",
    page: 1,
};

const filterSlice = createSlice({
    name: "filterProducts",
    initialState,
    reducers: {
        setAllProducts: (state, action) => {
            state.items = action.payload ;
        },
        searched: (state, action) => {
            state.search = action.payload;
            state.type = "";
            state.page = 1;
        },
        resetFilter: (state) => {
            state.type = "";
            state.search = "";
            state.page = 1;
        },
        pagination: (state, action) => {
            state.page = action.payload;
        }
    },
});

export default filterSlice.reducer;
export const { searched, resetFilter, pagination, setAllProducts } = filterSlice.actions;